/* ============================================================
   Revam Search Overlay (GTG-013) — mobile full-screen search.
   Opens the overlay from the header search icon; focuses the input;
   closes on Cancel / Esc / outside; locks body scroll.
   ============================================================ */
(function () {
  'use strict';
  if (window.__revamSearchOverlayInit) return;
  window.__revamSearchOverlayInit = true;

  function overlay() { return document.querySelector('[data-revam-search-overlay]'); }

  function open() {
    var el = overlay();
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('revam-search-open');
    var input = el.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    var el = overlay();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('revam-search-open');
    var ps = el.querySelector('revam-predictive-search');
    if (ps && typeof ps.close === 'function') ps.close(true);
  }

  // Capture phase + stopPropagation: the base theme's handler on
  // .site-header__search-toggle calls stopPropagation in the bubble phase,
  // so we must intercept earlier and block it from running.
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('[data-revam-search-open]')) {
        e.preventDefault();
        e.stopPropagation();
        open();
      } else if (e.target.closest('[data-revam-search-close]')) {
        e.preventDefault();
        e.stopPropagation();
        close();
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && overlay()?.classList.contains('is-open')) {
      close();
    }
  });

  // Click-and-drag (grab) horizontal scrolling for the Trending Searches row, so
  // mouse users can pan the chips by pressing and dragging — a plain mouse can't
  // scroll a horizontal-only row otherwise. Delegated on the overlay so it also
  // covers the cloned default panel. Touch devices keep their native scrolling.
  var dragRow = null;
  var dragStartX = 0;
  var dragStartScroll = 0;
  var didDrag = false;

  function onOverlayMouseDown(e) {
    if (e.button !== 0) return; // left button only
    var row = e.target.closest && e.target.closest('.revam-default-trending');
    if (!row || row.scrollWidth <= row.clientWidth) return;
    dragRow = row;
    didDrag = false;
    dragStartX = e.pageX;
    dragStartScroll = row.scrollLeft;
    row.classList.add('is-grabbing');
  }

  document.addEventListener('mousemove', function (e) {
    if (!dragRow) return;
    var walk = e.pageX - dragStartX;
    if (Math.abs(walk) > 4) didDrag = true; // distinguish a drag from a click
    dragRow.scrollLeft = dragStartScroll - walk;
    e.preventDefault();
  });

  document.addEventListener('mouseup', function () {
    if (!dragRow) return;
    dragRow.classList.remove('is-grabbing');
    dragRow = null;
    // Keep didDrag set through the click that immediately follows mouseup,
    // then clear it, so a real drag doesn't also trigger chip navigation.
    setTimeout(function () { didDrag = false; }, 0);
  });

  var overlayEl = overlay();
  if (overlayEl) {
    overlayEl.addEventListener('mousedown', onOverlayMouseDown);
    overlayEl.addEventListener('click', function (e) {
      if (didDrag && e.target.closest('.revam-default-trending')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    // Stop the native link/text drag-ghost while panning.
    overlayEl.addEventListener('dragstart', function (e) {
      if (e.target.closest('.revam-default-trending')) e.preventDefault();
    });
  }
})();
